import React from 'react';

import { type BaseSvgProps, colorToHexCode } from '../../utils';

export const ExpandOpen = ({
  width = 28,
  primaryColorHexCode = colorToHexCode.black,
  'data-testid': testId,
}: BaseSvgProps) => (
  <svg
    data-testid={testId}
    width={width}
    height={width}
    viewBox="0 0 27 27"
    className="shrink-0"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.1866 12.48L19.1866 8.68L14.7333 13.1333L14 12.4L18.4533 7.94667L14.6533 7.94667L14.6533 7L20.1333 7L20.1333 12.48L19.1866 12.48Z"
      fill={primaryColorHexCode}
    />
    <path
      d="M7.94667 14.6533L7.94667 18.4533L12.4 14L13.1333 14.7333L8.68 19.1866L12.48 19.1866L12.48 20.1333L7 20.1333L7 14.6533L7.94667 14.6533Z"
      fill={primaryColorHexCode}
    />
  </svg>
);
